module.exports = __webpack_public_path__ + "img/chart-running-run-steps.fceb169f.png";